module.exports = __webpack_public_path__ + "static/media/ic-metadium-logo.f2a642f0.svg";